import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, isRef as _isRef, withCtx as _withCtx, createVNode as _createVNode } from "vue"

import { useField } from "vee-validate";
import { useAttrs } from "vue";

interface AutocompleteItem {
    value: number;
    label: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'AbitDropAutocomplete',
  props: {
    name: {},
    label: {},
    horizontal: { type: [String, Boolean] },
    required: { type: Boolean },
    autocomplete: {},
    wrapperClass: {}
  },
  setup(__props: any) {

const props = __props;

const attrs = useAttrs();

const { value, errorMessage } = useField(props.name);

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
            props.wrapperClass || 'a',
            props.horizontal && 'horizontal-wrapper',
        ])
  }, [
    _createElementVNode("label", {
      class: _normalizeClass([
                'form-label',
                props.required && 'required',
                props.horizontal && 'horizontal',
            ])
    }, _toDisplayString(props.label), 3),
    _createVNode(_component_el_form_item, {
      error: _unref(errorMessage),
      class: _normalizeClass(props.horizontal ? 'form-item-horizontal' : ''),
      validateStatus: _unref(errorMessage) ? 'error' : 'success'
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_select, {
          modelValue: _unref(value),
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(value) ? (value).value = $event : null)),
          multiple: "",
          filterable: "",
          "allow-create": "",
          "default-first-option": "",
          "reserve-keyword": false,
          placeholder: "Scegli uno o più tag"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.autocomplete, (item) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                key: item.value,
                label: item.label,
                value: item.value
              }, null, 8, ["label", "value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["error", "class", "validateStatus"])
  ], 2))
}
}

})